import type { RouteObject } from 'react-router';

import { PersonDetailPage } from './PersonDetail';

/**
 * `/people/:profileSlug` — one `RouteObject`, so the file is `.route.tsx`
 * singular.
 *
 * **The segment is the slug, not the id**, and the name says so rather than
 * carrying one value under the other's label. `backend-content` publishes no
 * operator read for a profile by id — only its API-key-gated internal surface
 * calls that service method — while `GET /creditHolders/{profileSlug}` serves
 * the same record. The id every write on this page needs arrives inside that
 * payload.
 */
export const peopleDetailRoute: RouteObject = {
  path: '/people/:profileSlug',
  element: <PersonDetailPage />,
};
